import React from "react";

import Filter from "../Components/Filter";

export default function Header({ t, setDataFilter, filtersLists, isOpen = false }) {
  return (
    <Filter
      classButton="arh-flex arh-w-1/2 arh-justify-end arh-space-x-10"
      classChild="arh-flex arh-w-1/2 arh-justify-start arh-space-x-10"
      classParent="arh-flex arh-w-full arh-items-center arh-justify-between arh-bg-greyColor arh-p-4"
      setDataFilter={setDataFilter}
      t={t}
      filtersLists={filtersLists}
      isOpen={isOpen}
    />
  );
}
